import { combineReducers, type EnhancedStore } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'
import { layoutConfigurationSlice } from '#store/layoutConfiguration'
import { requestObserverSlice } from '#store/requestObserverSlice'
import { componentConfigurationSlice } from './componentConfiguration'
import { debugSlice } from './debugConfiguration'

export const sharedSlices = {
  [componentConfigurationSlice.reducerPath]: componentConfigurationSlice.reducer,
  [requestObserverSlice.reducerPath]: requestObserverSlice.reducer,
  layoutConfiguration: layoutConfigurationSlice,
  [debugSlice.reducerPath]: debugSlice.reducer,
} as const

const rootReducer = combineReducers(sharedSlices)

// this is a virtual type that is used to improve the typing of `useSelector`, given that the consuming application and
// its store combined the required reducer in its store
type RootState = ReturnType<typeof rootReducer>

export type SharedStore = EnhancedStore<RootState>
export type SharedAppDispatch = SharedStore['dispatch']

export const useSharedAppDispatch = useDispatch.withTypes<SharedAppDispatch>()
export const useSharedAppSelector = useSelector.withTypes<RootState>()
